import { Universe } from "../universe/universe";

export class Tags {
  tagType: TagType[];
}

export class TagType {
  tagTypeKey?: number;
  tagTypeName: string;
  tags: Tag[];
  isActive?: boolean;
  universes?: Universe[];
  completed?: boolean;

  constructor(tagTypeName: string, universes?: Universe[]) {
    this.tagTypeName = tagTypeName;
    this.universes = universes;
  }
}

export class Tag {
  tagKey?: number;
  tagTypeKey: number;
  tagName: string;
  completed?: boolean;
  colorKey?: number;
  isActive?: boolean;

  constructor(tagTypeKey: number, tagName: string, colorKey: number, isActive: boolean = true, completed: boolean = true) {
    this.tagTypeKey = tagTypeKey;
    this.tagName = tagName;
    this.colorKey = colorKey;
    this.isActive = isActive;
    this.completed = completed;
  }
}
export class TagCheckBox {
  tagKey: number;
  tagName: string;
  completed: boolean;
}



